const STORAGE_KEY = 'postLoginRedirect';

/** Same-origin paths only: must start with `/` and reject `//…` (protocol-relative / open-redirect bait). */
export function isSafeInternalRedirect(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//');
}

export function setPostLoginRedirect(pathnameAndSearch: string): void {
  if (!isSafeInternalRedirect(pathnameAndSearch)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, pathnameAndSearch);
  } catch {
    /* ignore */
  }
}

/** Returns stored path and clears it (single use). */
export function consumePostLoginRedirect(): string | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw || !isSafeInternalRedirect(raw)) return null;
    sessionStorage.removeItem(STORAGE_KEY);
    return raw;
  } catch {
    return null;
  }
}
